import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { WalletCheckFormComponent } from './wallet-check-form/wallet-check-form.component';

@Component({
  selector: 'olv-wallet-check',
  standalone: true,
  imports: [WalletCheckFormComponent],
  templateUrl: './wallet-check.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./wallet-check.component.scss'],
})
export class WalletCheckComponent {
  merchantId = input.required<string>();
}
